import { API, authClient } from "../index";

export const postCustomer = async (customer, accessToken) => {
	return authClient(accessToken).post(`${API}/customers`, customer);
};

export const getCustomers = (accessToken) => {
	return authClient(accessToken).get(`${API}/customers`);
};

export const getCustomerById = (id, accessToken) => {
	return authClient(accessToken).get(`${API}/customers/${id}`);
};

export const updateCustomer = async (id, customer, accessToken) => {
	return authClient(accessToken).put(`${API}/customers/${id}`, customer);
};

export const changeStatusCustomer = async (id, active, accessToken) => {
	return authClient(accessToken).put(
		`${API}/customers/${id}/status?active=${active}`
	);
};

export const deleteCustomer = (id, accessToken) => {
	return authClient(accessToken).delete(`${API}/customers/${id}`);
};
